import { PanelCard, ToggleField } from './panelUi'
import { getSetting, type UserSettings } from './useUserSettings'
import { useWriteSettings } from './useWriteSettings'

/**
 * Recommendation settings — subset of the desktop panel. The PWA doesn't
 * surface per-genre preferences (the desktop does via a dedicated UI); it
 * only exposes the three master toggles that control whether recommendation
 * and interaction-tracking features run at all.
 */
export function RecommendationSettingsPanel({
  settings,
}: {
  settings: UserSettings | null
}) {
  const { updateSetting } = useWriteSettings()

  const enabled = getSetting(settings, 'recommendationSystemEnabled')
  const personalized = getSetting(settings, 'enablePersonalizedRecommendations')
  const track = getSetting(settings, 'trackUserInteractions')

  return (
    <PanelCard title="Recommendations">
      <ToggleField
        label="Recommendation system"
        description="Master toggle for the recommendation engine"
        checked={Boolean(enabled)}
        onChange={(v) => updateSetting('recommendationSystemEnabled', v)}
      />

      <ToggleField
        label="Personalized recommendations"
        description="Use your ratings and watch history to tailor suggestions"
        checked={Boolean(personalized)}
        disabled={!enabled}
        onChange={(v) => updateSetting('enablePersonalizedRecommendations', v)}
      />

      <ToggleField
        label="Track user interactions"
        description="Record views, ratings, and clicks to improve recommendations"
        checked={Boolean(track)}
        disabled={!enabled}
        onChange={(v) => updateSetting('trackUserInteractions', v)}
      />
    </PanelCard>
  )
}
